import reducer, { initialState } from '../../reducers/verifyCode';
import * as actions from '../../actions/verifyCode';

const fn = { reducer, initialState, actions };
export default fn;
 
